import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const UlcerPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Ulcers</h1>
        <section className="mb-8">
          <p>Ulcers are open sores that develop in the lining of the stomach or small intestine. Our natural therapies focus on healing the ulcer, reducing inflammation, and preventing recurrence through gentle, effective herbal remedies and lifestyle modifications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>H. pylori infection</li>
            <li>Excessive acid production</li>
            <li>Stress and anxiety</li>
            <li>Poor dietary habits</li>
            <li>Certain medications</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Burning stomach pain</li>
            <li>Bloating and fullness</li>
            <li>Nausea and vomiting</li>
            <li>Loss of appetite</li>
            <li>Weight loss</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use healing herbs, acid-reducing remedies, and lifestyle modifications to naturally treat ulcers. Our approach focuses on promoting healing, reducing inflammation, and preventing recurrence through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural healing</li>
            <li>Reduced inflammation</li>
            <li>No harsh side effects</li>
            <li>Long-term relief</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Eat smaller, frequent meals</li>
            <li>Avoid spicy and acidic foods</li>
            <li>Manage stress levels</li>
            <li>Quit smoking and alcohol</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to heal an ulcer?</strong>
            <p>A: Most ulcers heal within 4-8 weeks with consistent treatment and lifestyle changes.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management of ulcers.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing underlying causes and promoting healing.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from ulcers—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default UlcerPage; 